import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserCrm } from '../../../model/UserCrm';
import HttpClient, { Callback, CallbackType, ExtraAction } from '../api';
import { Pageable, PaginatedCollection } from '../../../model/Pagination';

const pageable: Pageable = {
  sort: {
    unsorted: true,
    sorted: false,
    empty: true,
  },
  offset: 0,
  pageNumber: 0,
  pageSize: 10,
  paged: true,
  unpaged: false,
};

const INITIAL_STATE: PaginatedCollection<UserCrm> = {
  content: [],
  size: 0,
  totalElements: 0,
  totalPages: 0,
  number: 0,
  first: false,
  numberOfElements: 0,
  empty: false,
  last: false,
  pageable,
  category: '',
  sort: {
    unsorted: false,
    sorted: false,
    empty: false,
  },
};

const usersSlice = createSlice({
  name: 'usersCrm',
  initialState: INITIAL_STATE,
  reducers: {
    addUserCrm: (state, action: PayloadAction<PaginatedCollection<UserCrm>>) => ({
      ...state,
      ...action.payload,
    }),
    updUserCrm: (state, action: PayloadAction<PaginatedCollection<UserCrm>>) => ({
      ...state,
      ...action.payload,
    }),
    delUserCrm: (state, action: PayloadAction<PaginatedCollection<UserCrm>>) => ({
      ...state,
      ...action.payload,
    }),
  },
});

export const { addUserCrm, updUserCrm, delUserCrm } = usersSlice.actions;

export default usersSlice.reducer;

export const findUserCrmByQuery = (
  apiQuery = new Map<string, string>(),
  extraActions?: Array<ExtraAction>,
  customErrorsMap = new Map<number, string>(),
  callbacks: Array<Callback> = [
    {
      type: CallbackType.SUCCESS,
      function: () => console.log('findUserCrmByCategory by query success'),
      full: false,
    },
  ],
) => {
  return HttpClient.findUserCrmByQuery(
    apiQuery,
    addUserCrm.type,
    customErrorsMap,
    extraActions,
    callbacks,
  );
};

export const updateUserCrm = (user: UserCrm, callbacks?: Array<Callback>) => {
  return HttpClient.updateUserCrm(user, updUserCrm.type, callbacks);
};
export const changeUserCrmPassword = (
  username: string,
  password: string,
  callbacks: Array<Callback>,
) => {
  return HttpClient.changeUserCrmPassword(username, password, updUserCrm.type, callbacks);
};

export const createUserCrm = (user: UserCrm, callbacks?: Array<Callback>) => {
  return HttpClient.createUserCrm(user, addUserCrm.type, callbacks);
};

export const deleteUserCrm = (userId: number, callbacks?: Array<Callback>) => {
  return HttpClient.deleteUserCrm(userId, delUserCrm.type, callbacks);
};
